module.exports = __webpack_public_path__ + "img/20180815_150609_091.2f8553f4.jpg";